import $ from '@vaersaagod/tools/Dom';

export default el => {

    const $el = $(el);
    const $button = $el.find('[data-btn]');
    const $container = $el.find('[data-embed]');

    let hasClicked = false;

    const onClick = e => {
        e.preventDefault();
        if (hasClicked) {
            return;
        }
        hasClicked = true;
        $container.html(JSON.parse($container.data('embed'))).attr('hidden', null);
    };

    const init = () => {
        $button.on('click', onClick);
    };

    const destroy = () => {
        $button.off('click', onClick);
    };

    return {
        init,
        destroy
    };

};



// WEBPACK FOOTER //
// ./src/js/components/VideoEmbed.js